import { useTranslation } from "react-i18next";
import Box from "@cloudscape-design/components/box";
import Icon from "@cloudscape-design/components/icon";

function ConversationBubble({ message, type }) {
  const { t } = useTranslation();
  const isUser = type === "user_speech";
  
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";
    try {
      // Handle Unix epoch (seconds) - multiply by 1000 for milliseconds
      const ts = typeof timestamp === "number" || /^\d+$/.test(timestamp) 
        ? Number(timestamp) * 1000 
        : timestamp;
      return new Date(ts).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false });
    } catch { return ""; }
  };

  const label = isUser ? t("conversation.bubble.user") : t("conversation.bubble.agent");

  return (
    <article className={`conversation-bubble ${isUser ? "user" : "agent"}`}>
      <div className="conversation-bubble-header">
        <div className="conversation-bubble-icon"><Icon name={isUser ? "user-profile" : "gen-ai"} /></div>
        <span className="conversation-bubble-label">{label}</span>
        <time className="conversation-bubble-timestamp">{formatTimestamp(message.timestamp)}</time>
      </div>
      <div className="conversation-bubble-content"><Box variant="p">{message.content}</Box></div>
    </article>
  );
}

export default ConversationBubble;
